import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  customVirtualBackgroundUploadRequested,
  virtualBackgroundChangeRequested,
} from 'features/virtual-backgrounds/actions';
import { changeVirtualBackgroundSaga } from 'features/virtual-backgrounds/sagas/changeVirtualBackgroundSaga';
import { deletePersistedBackgroundSaga } from 'features/virtual-backgrounds/sagas/deletePersistedBackgroundSaga';
import { onVirtualBackgroundUnsupportedSaga } from 'features/virtual-backgrounds/sagas/onVirtualBackgroundUnsupportedSaga';
import { persistCustomBackgroundSaga } from 'features/virtual-backgrounds/sagas/persistCustomBackgroundSaga';
import { preloadVirtualBackgroundSaga } from 'features/virtual-backgrounds/sagas/preloadVirtualBackgroundSaga';
import { preloadVirtualBackgroundOnPermissionsChangedSaga } from 'features/virtual-backgrounds/sagas/preloadVirtualBackgroundOnPermissionsChangedSaga';
import { resetVirtualBackgroundSaga } from 'features/virtual-backgrounds/sagas/resetVirtualBackgroundSaga';
import { initVirtualBackground } from 'features/virtual-backgrounds/thunks/initVirtualBackground';
import {
  customBackgroundDeleted,
  virtualBackgroundActivationFailed,
  virtualBackgroundReset,
} from 'features/virtual-backgrounds/virtualBackgroundsSlice';
import { authorizeUser } from 'features/room/thunks/authorizeUser';
import { broadcastPermissionGranted } from 'features/permissions/actions';

export default function* virtualBackgroundWatcher() {
  yield takeLatest(virtualBackgroundChangeRequested, changeVirtualBackgroundSaga);
  yield takeLatest(virtualBackgroundReset, resetVirtualBackgroundSaga);
  yield takeLatest(authorizeUser.fulfilled, preloadVirtualBackgroundSaga);
  yield takeLatest(broadcastPermissionGranted, preloadVirtualBackgroundOnPermissionsChangedSaga);
  yield takeEvery(customVirtualBackgroundUploadRequested, persistCustomBackgroundSaga);
  yield takeEvery(customBackgroundDeleted, deletePersistedBackgroundSaga);
  // Separate calls, not takeEvery([...]): a test importing this slice directly runs the root saga
  // before the slice finishes, and an array pattern holding an undefined creator spins forever.
  yield takeEvery(initVirtualBackground.rejected, onVirtualBackgroundUnsupportedSaga);
  yield takeEvery(virtualBackgroundActivationFailed, onVirtualBackgroundUnsupportedSaga);
}
